module.exports = __webpack_public_path__ + "img/archive.d3ba1ae7.png";